export enum RequestFieldsEnum {
  Basic = 'BASIC',
  Default = 'DEFAULT',
  Full = 'FULL',
}
